import * as React from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { useState, useEffect } from "react";

function createData(name, signDate, minorNum, birthDay, age, refNum, minors) {
  return {
    name,
    // signDate,
    signDate: `${new Intl.DateTimeFormat("en-US", {
      timeZone: "America/New_York", // Eastern Time (ET)
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true, // 12-hour format with AM/PM
    }).format(new Date(signDate))}`.slice(11),
    minorNum,
    birthDay,
    age,
    refNum,
    minors: minors,
  };
}

function Row(props) {
  const { row } = props;
  const [open, setOpen] = React.useState(false);

  return (
    <React.Fragment>
      <TableRow sx={{ "& > *": { borderBottom: "unset" } }}>
        <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell component="th" scope="row">
          {row.name}
        </TableCell>
        <TableCell align="right">{row.signDate}</TableCell>
        <TableCell align="right">{row.minorNum}</TableCell>
        <TableCell align="right">{row.birthDay}</TableCell>
        <TableCell align="right">{row.age}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box sx={{ margin: 1 }}>
              <Typography variant="h8" gutterBottom component="div">
                Minor(s)
              </Typography>
              <Table size="small" aria-label="purchases">
                <TableHead>
                  <TableRow>
                    <TableCell>Name</TableCell>
                    <TableCell>Birthday</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {row.minors.length > 0 ? (
                    row.minors.map((m) => (
                      <TableRow key={m.minorId}>
                        <TableCell component="th" scope="row">
                          {m.lastName}, {m.firstName}
                        </TableCell>
                        <TableCell>
                          {m.birthDateMonth}-{m.birthDateDay}-{m.birthDateYear}
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <></>
                  )}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}

function AgeCalculation(birthDay) {
  const today = new Date();
  const birth = new Date(birthDay);
  //   console.log(props.birthDate);
  //   console.log(props.birthDate + `10:45:31.123Z`);
  let deAge = today.getFullYear() - birth.getFullYear();
  const monthDifference = today.getMonth() - birth.getMonth();

  if (
    monthDifference < 0 ||
    (monthDifference === 0 && today.getDate() < birth.getDate())
  ) {
    deAge--;
  }
  //   const [age, setAge] = useState(deAge);

  // Adjust the age if the current date is before the birthday this year

  //   console.log(age);
  return deAge * 1 <= 0 ? "Less than 12 month" : deAge;
}
export default function WaiverTable(props) {
  const waiverData = props.waiverData;
  const [rows, setRows] = useState([createData("No Data", 0, 0, 0, 0, 0, 0)]);
  useEffect(() => {
    let rawData = [];
    if (waiverData.length !== 0) {
      waiverData.map((e) =>
        rawData.push(
          createData(
            `${e.lastName}, ${e.firstName}`,
            e.timeStamp,
            e.minors.length,
            `${e.birthDateMonth}-${e.birthDateDay}-${e.birthDateYear}`,
            AgeCalculation(
              `${e.birthDateYear}-${e.birthDateMonth}-${e.birthDateDay}`
            ),
            e._id,
            e.minors
          )
        )
      );
    }
    setRows(rawData);
  }, [waiverData]);
  //   const rows =
  //     waiverData.length !== 0
  //       ? props.waiverData.map((e)=>)
  //       : [createData("Frozen yoghurt", 159, 6.0, 24, 4.0, 3.99)];
  return (
    <TableContainer component={Paper} sx={{ maxHeight: `calc(86vh - 180px)` }}>
      <Table stickyHeader aria-label="collapsible table">
        <TableHead>
          <TableRow>
            <TableCell sx={{ width: "20px" }} />
            <TableCell sx={{ fontWeight: "bold" }}>Guardian</TableCell>
            <TableCell align="right" sx={{ fontWeight: "bold" }}>
              Signed Time
            </TableCell>
            <TableCell align="right" sx={{ fontWeight: "bold" }}>
              Minor(s)
            </TableCell>
            <TableCell align="right" sx={{ fontWeight: "bold" }}>
              Birthday
            </TableCell>
            <TableCell align="right" sx={{ fontWeight: "bold" }}>
              Age
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => (
            <Row key={row.refNum} row={row} sx={{ alignText: "right" }} />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
